import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Image } from 'react-bootstrap'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { userManager } from 'utils/authHelpers'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'

import './LogoutPage.scss'
import AuthContext from 'contexts/AuthContext'
import { useLogoHelper } from 'utils/logoHelper'
import { useSearchParams } from 'react-router-dom'

function LogoutPage() {
	const [error, setError] = React.useState<Error>()
	const { t } = useTranslation()
	const [searchParams] = useSearchParams()
	const { whiteLogo } = useLogoHelper()

	const { isAuthenticated } = useContext(AuthContext)
	useEffect(() => {
		console.log('is auth', isAuthenticated)
		var applicationId =
			sessionStorage.getItem('applicationid') ??
			localStorage.getItem('applicationId')

		var reason = searchParams.get('reason')
		isAuthenticated &&
			userManager.signoutRedirect({
				id_token_hint: sessionStorage.getItem('id_token'),
				state: { applicationId: applicationId, reason: reason },
			})
		userManager.clearStaleState()
		// eslint-disable-next-line
	}, [])

	const ErrorButton = () => {
		return (
			<button
				className="btn btn-outline-danger"
				onClick={() => setError(undefined)}>
				{t('Close')}
			</button>
		)
	}

	return (
		<div id="logout-page">
			<div className="logout-container">
				<Image
					src={whiteLogo}
					className="tfbank-logo logout"
					alt={'TF Bank'}
				/>
				{error ? (
					<div className="error-container">
						<ErrorBox
							message={error.message}
							button={<ErrorButton />}
						/>
					</div>
				) : (
					<div className="spinner-container">
						<CircleSpinner />
					</div>
				)}
			</div>
		</div>
	)
}
export default LogoutPage
